import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ErrorHandler } from '../../common/errorHandler';
import { AuthenticationService } from '../../services/authentication.service';
import { GroupService } from '../../services/group.service';
import { Group } from '../../models/group.model';
import { AccessRight } from '../../enums/access.right.enum';

@Component({
    selector: 'group-list',
    templateUrl: './group-list.component.html',
    styleUrls: ['./group-list.component.css'],
    providers: [GroupService, ErrorHandler]
})
export class GroupListComponent implements OnInit {
    groups: Array<Group>;
    isDataAvailable = false;

    constructor(
        private router: Router,
        private errorHandler: ErrorHandler,
        private groupService: GroupService)
    {
        this.groups = new Array<Group>();
    }

    ngOnInit() {
        this.getAll();
    }

    getAll(): void {
        this.groupService.getGroups()
            .then(groups => {
                this.groups = groups;
                this.isDataAvailable = true;
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    edit(groupId: string): void {
        this.router.navigate(['group/detail', groupId]);
    }

    add(): void {
        this.router.navigate(['group/detail', 0]);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/group-list/group-list.component.ts